import { Component, OnInit, OnDestroy, Optional, Inject, HostListener } from '@angular/core';
import { EMailService } from '../../services/email.service';
import { MatDialog } from '@angular/material/dialog';
import { Email } from '../../models/e-mail.model';
import { Emailresponse } from '../../models/emailresponse.model';
import { EditEmailComponent } from './editEmail/editEmail.component';
import { UpdateEmailComponent } from './updateEmail/updateEmail.component';
import { AddEmailComponent } from './addEmail/addEmail.component';
import { DeleteEmailComponent } from './deleteEmail/deleteEmail.component';
import { ModernOneClickEnrollComponent } from '../oneClickEnroll/one-click-enroll.component';
import { Observable } from 'rxjs';
import { Subscription, combineLatest } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'edelivery-email',
    templateUrl: './edelivery-email.component.html',
    styleUrls: ['./edelivery-email.component.css']
})
export class EdeliveryEmailComponent implements OnInit, OnDestroy {
    emailresponse: Observable<Emailresponse>;
    emails: Email[] = [];
    userFromMyClientView: boolean;
    error: boolean = false;
    private AddEmailSubscription: Subscription;
    combinedSubscription: Subscription;
    errorSubscription: Subscription;
    response: any;

    // Labels
    emailTitle = EdeliveryLabels.EMAIL_TITLE;
    addEmailAddress = EdeliveryLabels.ADD_EMAIL_ADDRESS;
    noEmailSetupMessage = EdeliveryLabels.NO_EMAIL_SETUP_MESSAGE;
    editLabel: any = EdeliveryLabels.EDIT_LABEL;
    updateLabel: any = 'UPDATE';
    deleteLabel: any = EdeliveryLabels.DELETE_LABEL;
    adaTheme: boolean = false;
    edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;
    emailSetupMessage = EdeliveryLabels.EMAIL_SETUP_MESSAGE;

    errorMessage = 'Due to a system error, the functionality you\'re attempting to use is not available currently. Please try again.';
    constructor(
        private emailService: EMailService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private translate: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any
        ) {
            if (appSettings.ibdConfigMap) {
                this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
            }
            if (this.translate) {
                this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
            }
            if (appSettings.themeType === 'ada') {
                this.adaTheme = true;
            }
    }
    ngOnInit(): void {
        this.AddEmailSubscription = this.emailService.addEmailObservable$.subscribe(response => {
            if (response) {
                this.updateEmail();
            }
        });
        this.emailService.retrieveEmails();

        this.combinedSubscription = combineLatest(this.emailService.emailresponse$, this.route.queryParamMap)
            .subscribe(([emailResponse, routeResponse]) => {
                if (routeResponse !== null && emailResponse !== null) {
                    this.emails = emailResponse.emails;
                    console.log('email response: ', this.emails);
                    if (this.emails.length === 0 && routeResponse.get('showPopup') === 'true' && this.emailService.EmailPopupAlreadyTriggered === false) {
                        this.addEmail();
                        this.emailService.showEmailPopup = true;
                        this.emailService.EmailPopupAlreadyTriggered = true;
                    }
                }
            },
        error => {
            console.log('error: ', error);
        });

        this.errorSubscription = this.emailService.error$.subscribe((emailErrorResponse) => {
        console.log('emailErrorResponse: ', emailErrorResponse);
        if (emailErrorResponse) {
            this.error = true;
        }
        });
    }
    addEmail(): void {
        this.dialog.open(AddEmailComponent, {panelClass: ['modal', 'edel-AddEmail']});
    }
    editEmail(email: Email): void {
        // Save the existing e-mail in old email
        email.oldEmailAddress = email.emailAddress;
        this.dialog.open(EditEmailComponent, {data: { email }, panelClass: ['modal', 'edel-EditEmail'], width: '60vw', id: 'edit' });
    }
    updateEmail(): void {
        // Save the existing e-mail in old email
        let emails = this.emails;
        this.dialog.open(UpdateEmailComponent, {data: { emails }, panelClass: ['modal', 'edel-EditEmail'], width: '60vw', id: 'edit' });
    }
    deleteEmail(email: Email): void {
        this.dialog.open(DeleteEmailComponent, {data: { email }, panelClass: ['modal', 'edel-DeleteEmail']});
    }
    oneClickEnroll(): void {
        // email.oldEmailAddress = email.emailAddress;
        this.dialog.open(ModernOneClickEnrollComponent, {width: '80%', height: '80%', panelClass: ['modal', 'edel-AddEmail'], disableClose: true, data: {showInterstitial:false}});
    }
    @HostListener('document:portal.nxiOneClickAcceptEvent', ['$event'])
    oneClickAcceptEventHandle(event: any) {
        if (location.href.includes('default-settings')) {
            this.emailService.retrieveEmails();
        }
    }
    ngOnDestroy(): void {
        this.AddEmailSubscription.unsubscribe();
     }
}
